import { render, staticRenderFns } from "./CheckWeights.vue?vue&type=template&id=3424a8ae&scoped=true"
import script from "./CheckWeights.vue?vue&type=script&lang=ts"
export * from "./CheckWeights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424a8ae",
  null
  
)

export default component.exports